"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNoIdPromise = exports.toArray = exports.collectionsUrlPart = exports.getId = void 0;
var container_1 = require("../services/container/container");
var noModelIdError = 'modelOrId does not contain id';
function getId(modelOrId) {
    if (typeof modelOrId === 'string' || typeof modelOrId === 'number') {
        return modelOrId;
    }
    if (typeof modelOrId === 'object' && modelOrId.id) {
        return modelOrId.id;
    }
    throw new Error(noModelIdError);
}
exports.getId = getId;
function collectionsUrlPart(collectionOrId) {
    return "collections/" + getId(collectionOrId);
}
exports.collectionsUrlPart = collectionsUrlPart;
function toArray(data) {
    if (data instanceof Array) {
        return data;
    }
    return [data];
}
exports.toArray = toArray;
function getNoIdPromise() {
    return container_1.MyPromise.reject(noModelIdError);
}
exports.getNoIdPromise = getNoIdPromise;
//# sourceMappingURL=_helpers.js.map